import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import { useAuthStore } from "@/stores";
import type IEmailQueue from "@/models/responses/IEmailQueue";

export const useEmailQueueStore = defineStore("email-queue", {
  state: () => ({
    error: "" as any,
  }),
  actions: {
    async load(referenceCode: string) {
      const authStore = useAuthStore();
      const { isAuthenticated } = storeToRefs(authStore);
      if (!isAuthenticated.value) return;

      this.error = "";
      return await api
        .get<IEmailQueue>(`v1.0/email-queue?referenceCode=${encodeURIComponent(referenceCode)}`)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          this.error = error;
          return undefined;
        });
    },
  },
});
